import { combineReducers } from "redux";
import staticDataReducer from "./staticData/staticDataReducer";
import headerReducer from "./header/headerReducer";
import AppUserDataReducer from "./appUserData/AppUserDataReducer";
import ApplicationStateReducer from "./applicationState/ApplicationStateReducer";
import ActiveMenuReducer from "./activeMenu/ActiveMenuReducer";
import SelectedTabReducer from "./selectedTab/SelectedTabReducer";
import AdminHeaderReducer from "./adminPanel/header/AdminHeaderReducer";
import AdminAppUserDataReducer from "./adminPanel/appUserData/AdminAppUserDataReducer";
import AppUserRoleReducer from "./adminPanel/appUserRole/AppUserRoleReducer";
import AccountSettingReducer from "./accountSetting/AccountSettingDataReducer";
import AdminStaticDataReducer from "./adminPanel/staticData/AdminStaticDataReducer";
import CrmIntegrationReducer from "./crmIntegration/CrmIntegrationReducer";
import SelectedDomainReducer from "./selectedDomain/SelectedDomainReducer";
import PaginationRowReducer from "./paginationRow/PaginationRowReducer";
import AdminPaginationRowReducer from "./adminPanel/paginationRow/AdminPaginationRowReducer";

const appReducer = combineReducers({
  staticData: staticDataReducer,
  header: headerReducer,
  appUserData: AppUserDataReducer,
  applicationState: ApplicationStateReducer,
  activeMenu: ActiveMenuReducer,
  selectedTab: SelectedTabReducer,
  accountSetting: AccountSettingReducer,
  appUserRole: AppUserRoleReducer,
  crmIntegration: CrmIntegrationReducer,
  businessDomain: SelectedDomainReducer,
  paginations: PaginationRowReducer,
  adminHeader: AdminHeaderReducer,
  adminUserDetails: AdminAppUserDataReducer,
  adminStaticData: AdminStaticDataReducer,
  adminPaginations: AdminPaginationRowReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_ACTION" || action.type === "USER_LOGOUT") {
    state = undefined;
  }

  return appReducer(state, action);
};
export default rootReducer;
